module.exports = __webpack_public_path__ + "img/icon.70d68b24.png";